/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cute_Mean_Slug_TrustInputs */

const fr_cute_mean_slug_trust = /** @type {(inputs: Cute_Mean_Slug_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut, le % est calculé sur l'exercice sélectionné. Vous pouvez choisir un autre exercice de référence.`)
};

/**

* @param {Cute_Mean_Slug_TrustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cute_mean_slug_trust = /** @type {((inputs?: Cute_Mean_Slug_TrustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cute_Mean_Slug_TrustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cute_mean_slug_trust(inputs)
});